import React, { useState } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import Modal from '@mui/material/Modal';
import { jsonEditorStyles } from './jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import { Box, Typography, TextField, Link, AccordionSummary, Accordion, AccordionDetails, FormControlLabel, Checkbox, SelectChangeEvent } from '@mui/material';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { getLastPolicies, getJsonEditor, getSessionId, setLastPolicies, getTemplatizationEnvironments } from '../../store';
import any from 'react/jsx-runtime';
import { ExpandMore } from '@mui/icons-material';
import { OptionProps, PolicyRecord, SamlTPMetdataUrl } from '../../view-models';
import { CircularProgress } from '@mui/material';
import { BuildSettings, getTenantSettings } from '../../jsonParsing/utils';
import { SelectComponent, TextComponent, TooltipComponent } from '../uiComponents';
import { validateJson } from '../../jsonParsing/jsonValidation/jsonValidation';
import { generatePolicyXML, RelyingPartyReference } from '../../jsonParsing/policyXMLGeneration';
import settings from '../../constants/jsonXMLsettings';
import { deleteMultiplePolicies, getRunNowLink, uploadPolicyToRemote } from '../../jsonParsing/policyUpload';
import jsonConstants from '../../constants/jsonConstants';
import { envExists, envHasEmptySettings } from './utils';

export const testGenerateXML = (
  jsonEditor: any,
  sessionID: string,
  lastPolicies: PolicyRecord[],
  onDeploy: Function,
  setDeployState: any,
  updateLastPolicies: any,
  deploymentEnv: string,
  otherSettings?: any,
) => {
  let jsonValidationErrors = validateJson(jsonEditor);
  if (
    jsonValidationErrors.some((errReport) => {
      return errReport.errors.length > 0;
    })
  ) {
    setDeployState('jsonError');
    onDeploy();
  } else {
    let rawXMLoutput: {
      policyXML: string;
      relyingParties: RelyingPartyReference[];
      testNowUris: string[];
      allPolicyNames: string[];
      buildSettings: BuildSettings;
    } | null = null;
    try {
      rawXMLoutput = generatePolicyXML(jsonEditor as { [id: string]: any }, sessionID, { ...otherSettings, targetEnvironment: deploymentEnv }, jsonEditor.templatization);
    } catch (error) {
      console.error(error);
      setDeployState('buildError');
      onDeploy();
    }
    if (rawXMLoutput) {
      if (settings.showGeneratedXMLInConsole) {
        console.log(rawXMLoutput.policyXML);
        rawXMLoutput.relyingParties.forEach((rpInfo: RelyingPartyReference, index: number) => {
          console.log(rpInfo.xml);
        });
      }
      setDeployState('uploading');
      onDeploy();
      uploadPolicyToRemote(
        rawXMLoutput.policyXML,
        rawXMLoutput.allPolicyNames[rawXMLoutput.allPolicyNames.length - 1],
        rawXMLoutput.relyingParties,
        sessionID,
        jsonEditor,
        rawXMLoutput.buildSettings.xmlGenerationSettings.targetEnvironment!,
      ).then(({ success, uploadedNames }) => {
        let newPolicyNames: PolicyRecord[] = [];
        lastPolicies.forEach((pr) => {
          newPolicyNames.push(pr);
        });
        if (success && settings.performAutoDeletion) {
          deleteMultiplePolicies(
            lastPolicies.map((lp) => lp.policyName),
            jsonEditor.templatization.environments[deploymentEnv].settings[jsonConstants.defaultAppSettingFields.tenantName.id],
          ).then(({ success, deletedNames }) => {
            deletedNames.forEach((dn) => {
              let ind = newPolicyNames.findIndex((pr) => {
                return pr.policyName === dn;
              });
              if (ind) {
                newPolicyNames.splice(ind, 1);
              }
            });
            uploadedNames.forEach((un) => {
              let rpRef = rawXMLoutput?.relyingParties.find((rpInfo) => {
                return rpInfo.policyName === un;
              });
              newPolicyNames.push({
                policyName: un,
                runUri: rpRef ? getRunNowLink(rpRef.policyName, rawXMLoutput!.buildSettings, rpRef.isSamlPolicy) : '',
                isSaml: rpRef ? rpRef.isSamlPolicy : false,
                samlTPMetadataUrls: rpRef?.samlIdPMetadataUrls ? Object.keys(rpRef.samlIdPMetadataUrls).map((tpName: string) => { return { tpName: tpName, url: rpRef!.samlIdPMetadataUrls![tpName]}}) : null
              });
            });
            updateLastPolicies(newPolicyNames);
            rawXMLoutput?.relyingParties.forEach((rpXML: RelyingPartyReference, index: number) => {
              console.log(`   Test run at: ${rawXMLoutput?.testNowUris[index]}`);
            });
            setDeployState('success');
          });
        } else {
          if (!settings.performAutoDeletion) {
            newPolicyNames = uploadedNames.map((un) => {
              let rpRef = rawXMLoutput?.relyingParties.find((rpInfo) => {
                return rpInfo.policyName === un;
              });
              return {
                policyName: un,
                runUri: rpRef ? getRunNowLink(rpRef.policyName, rawXMLoutput!.buildSettings, rpRef.isSamlPolicy) : '',
                isSaml: rpRef ? rpRef.isSamlPolicy : false,
                samlTPMetadataUrls: rpRef?.samlIdPMetadataUrls ? Object.keys(rpRef.samlIdPMetadataUrls).map((tpName: string) => { return { tpName: tpName, url: rpRef!.samlIdPMetadataUrls![tpName]}}) : null
              };
            });
          } else {
            uploadedNames.forEach((un) => {
              let rpRef = rawXMLoutput?.relyingParties.find((rpInfo) => {
                return rpInfo.policyName === un;
              });
              newPolicyNames.push({
                policyName: un,
                runUri: rpRef ? getRunNowLink(rpRef.policyName, rawXMLoutput!.buildSettings, rpRef.isSamlPolicy) : '',
                isSaml: rpRef ? rpRef.isSamlPolicy : false,
                samlTPMetadataUrls: rpRef?.samlIdPMetadataUrls ? Object.keys(rpRef.samlIdPMetadataUrls).map((tpName: string) => { return { tpName: tpName, url: rpRef!.samlIdPMetadataUrls![tpName]}}) : null
              });
            });
            setDeployState('failed');
          }
          updateLastPolicies(newPolicyNames);
          if (success) {
            rawXMLoutput?.relyingParties.forEach((rpXML: RelyingPartyReference, index: number) => {
              console.log(`   Test run at: ${rawXMLoutput?.testNowUris[index]}`);
            });
            setDeployState('success');
          }
        }
      });
    }
  }
};

interface PolicyUploadUIProps {
  deployState: string;
  showPolicyName: boolean;
  deploymentTenantId: string;
}

interface PolicyUploadUIModalProps {
  closeComponent: any;
  deployState: string;
  deploymentEnv: string;
  setDeploymentEnv: Function;
  enableJavascript: boolean;
  setEnableJavascript: Function;
  journeyInsightsSettings: any;
  setJourneyInsightsSettings: Function;
  setShow: Function;
  setDeployState: Function;
}

export const PolicyUploadUIComponent = ({ deployState, showPolicyName, deploymentTenantId }: PolicyUploadUIProps) => {
  const lastPolicies = useSelector(getLastPolicies);
  const classes: any = jsonEditorStyles();

  return (
    <div>
      {deployState === 'success' && (
        <div className={cn(classes.flexCol)}>
          <Box className={cn(classes.flexRow)} sx={{ width: '80%', p: 2 }}>
            <Typography>Journeys Deployed Successfully:</Typography>
          </Box>
          {lastPolicies.map((pr: PolicyRecord, pindex: number) => {
            return (
              pr.runUri && (
                <Box className={cn(classes.flexCol)} key={pindex}>
                  <Box className={cn(classes.flexSpacedRow)} sx={{ py: 2 }}>
                    {showPolicyName && <Typography sx={{ px: 2, textAlign: 'center' }}>{pr.policyName}:</Typography>}
                    <Link href={pr.runUri} sx={{ px: 2, textAlign: 'center' }} target="_blank" rel="noopener">
                      <Typography>Test Authentication Journey</Typography>
                    </Link>
                    <Box className={cn(classes.flexRow)} sx={{ flex: '1', alignItems: 'center' }}>
                      <Typography sx={{ pl: 2 }}>Full test link:</Typography>
                      <TextField
                        size="small"
                        fullWidth
                        variant="outlined"
                        value={pr.runUri}
                        sx={{ flex: '3', px: 2 }}
                      />
                    </Box>
                  </Box>
                  {pr.isSaml && (
                    <>
                      <Box className={cn(classes.flexSpacedRow)} sx={{ pb: 1, pl: 6, alignSelf: 'flex-start' }}>
                        <Typography variant="body1">
                          This journey issues SAML tokens. To test it, copy the Tenant Name and
                          B2C Policy values from below into the fields at the above link and select "Login".
                        </Typography>
                      </Box>
                      <Box className={cn(classes.flexSpacedRow)} sx={{ py: 1, pl: 6, alignSelf: 'flex-start' }}>
                        <Box className={cn(classes.flexCol)} sx={{ pr: 2 }}>
                          <Typography variant="body1">Tenant Name:</Typography>
                          <Typography variant="body1">B2C Policy:</Typography>
                        </Box>
                        <Box className={cn(classes.flexCol)}>
                          <Typography variant="body1">{deploymentTenantId}</Typography>
                          <Typography variant="body1">{pr.policyName}</Typography>
                        </Box>
                      </Box>
                    </>
                  )}
                  {pr.samlTPMetadataUrls && (pr.samlTPMetadataUrls.length > 0) && (
                    <>
                      <Box className={cn(classes.flexSpacedRow)} sx={{ pb: 1, pl: 6, alignSelf: 'flex-start' }}>
                        <Typography variant="body1">
                          This journey federates with SAML IdPs. For each SAML IdP authentication component in the journey, see the entry in the list below for its SAML metadata URL.
                        </Typography>
                      </Box>
                      <Box className={cn(classes.flexSpacedRow)} sx={{ py: 1, pl: 6, alignSelf: 'flex-start' }}>
                        <Box className={cn(classes.flexCol)} sx={{ pr: 2 }}>
                          {pr.samlTPMetadataUrls.map((smUrl: SamlTPMetdataUrl, smDex: number) => {
                            return (
                              <Box className={cn(classes.flexRow)} sx={{alignItems: 'center'}} key={smDex}>
                                <Typography variant="body1">{smUrl.tpName}:</Typography>
                                <TextField
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  value={smUrl.url}
                                  sx={{ flex: '3', px: 2 }}
                                />
                              </Box>
                            )
                          })}
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              )
            );
          })}
        </div>
      )}
      {deployState === 'uploading' && (
        <div className={cn(classes.flexCol)}>
          <Box className={cn(classes.flexRow)} sx={{ width: '80%', p: 2, alignItems: 'center' }}>
            <Typography>Deploying journeys...</Typography>
            <CircularProgress sx={{ p: 2 }} />
          </Box>
        </div>
      )}
      {deployState === 'jsonError' && (
        <Box className={cn(classes.flexRow)} sx={{ width: '80%', p: 2 }}>
          <Typography>Could not deploy: journey flowchart contains one or more errors.</Typography>
        </Box>
      )}
      {deployState === 'buildError' && (
        <Box className={cn(classes.flexRow)} sx={{ width: '80%', p: 2 }}>
          <Typography>Could not deploy: an internal error occurred while generating the journeys.</Typography>
        </Box>
      )}
      {deployState === 'failed' && (
        <Box className={cn(classes.flexRow)} sx={{ width: '80%', p: 2 }}>
          <Typography>Deployment failed: one or more files failed to upload.</Typography>
        </Box>
      )}
    </div>
  );
};

interface DeploymentSettingsFieldProps {
  deploymentEnv: string;
  setDeploymentEnv: Function;
  enableJavascript: boolean;
  setEnableJavascript: Function;
  lockJavascriptField: boolean;
  journeyInsightsSettings: any,
  setJourneyInsightsSettings: Function,
  containerStyle: any;
  style: any;
}

export const DeploymentSettingsField = ({
  deploymentEnv,
  setDeploymentEnv,
  enableJavascript,
  setEnableJavascript,
  lockJavascriptField,
  journeyInsightsSettings,
  setJourneyInsightsSettings,
  containerStyle,
  style,
}: DeploymentSettingsFieldProps) => {
  const [showDeploymentSettings, setShowDeploymentSettings] = useState(false);
  const allEnvs = useSelector(getTemplatizationEnvironments);

  return (
    <Box sx={containerStyle}>
      <Accordion
        expanded={showDeploymentSettings}
        onChange={(e: any, isExpanded: boolean) => {
          setShowDeploymentSettings(isExpanded);
        }}
        sx={style}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>Advanced Deployment Settings</AccordionSummary>
        <AccordionDetails>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent) => {
              setDeploymentEnv(e.target.value);
            }}
            data={{
              value: deploymentEnv,
              label: 'Deployment Target Environment',
              options: Object.keys(allEnvs).reduce((vs: OptionProps[], ke: string) => { if (allEnvs[ke].linked) { vs.push({ value: ke, label: allEnvs[ke].name }); }; return vs }, [])
            }}
          />
          <div className="description" style={{ marginLeft: '10px', marginBottom: '10px'}}>
            Only environments linked to a tenant are available for deployment.
          </div>
          <Box sx={{display: 'flex', flexDirection: 'column'}}>
            <FormControlLabel
              sx={{ m: 0, width: '300px' }}
              label='Force enabling of Javascript'
              control={
                <Checkbox
                  checked={enableJavascript}
                  disabled={lockJavascriptField}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setEnableJavascript(!enableJavascript);
                  }}
                />
              }
            />
            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <FormControlLabel
                sx={{ m: 0, width: '300px' }}
                label='Enable Journey Insights'
                control={
                  <Checkbox
                    checked={journeyInsightsSettings.enableJourneyInsights}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setJourneyInsightsSettings({
                        ...journeyInsightsSettings,
                        enableJourneyInsights: !journeyInsightsSettings.enableJourneyInsights
                      });
                    }}
                  />
                }
              />
              <TooltipComponent
                title='Journey Insights Instance'
                desc='The Application Insights instance that will be used for Journey Insights for a particular tenant corresponds to the instrumentation key set as the value of the "applicationInsightsInstrumentationKey" App Setting. Whether the Journey Insights client-side scripts are enabled can be configured by setting the "applicationInsightsClientEnabled" App Setting.'
              />
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

const PolicyUploadUIModalComponent = ({
  closeComponent,
  deployState,
  deploymentEnv,
  setDeploymentEnv,
  enableJavascript,
  setEnableJavascript,
  journeyInsightsSettings,
  setJourneyInsightsSettings,
  setDeployState,
}: PolicyUploadUIModalProps) => {
  const classes: any = jsonEditorStyles();
  const [preUploadView, setPreUploadView] = useState(true);

  const sessionID = useSelector(getSessionId);
  const lastPolicies = useSelector(getLastPolicies);
  const editorState = useSelector(getJsonEditor);
  const dispatch = useDispatch();

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          closeComponent();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.popup}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>Deploy Journeys</div>
          <div>
            <ClearOutlinedIcon
              onClick={() => {
                closeComponent();
              }}
              className={classes.delete}
            />
          </div>
        </div>
        {preUploadView && (
          <Box sx={{ display: 'flex', flexDirection: 'column', mx: 2 }}>
            <Button
              variant="contained"
              size="large"
              sx={{ width: '50%', my: 2, py: 2 }}
              onClick={(e) => {
                setDeployState('uploading');
                
                testGenerateXML(
                  editorState,
                  sessionID,
                  lastPolicies,
                  () => {
                    setPreUploadView(false);
                  },
                  setDeployState,
                  (npn: PolicyRecord[]) => {
                    dispatch(setLastPolicies(npn));
                  },
                  deploymentEnv,
                  {
                    enableJavascript: enableJavascript,
                    enableJourneyInsights: journeyInsightsSettings.enableJourneyInsights
                  },
                );
              }}
              disabled={(!envExists(editorState, deploymentEnv)) || envHasEmptySettings(editorState, deploymentEnv)}
            >
              Deploy Flowcharts
            </Button>
            {envHasEmptySettings(editorState, deploymentEnv) && (
              <Typography color="red">
                The selected environment for deployment has no value for one or more app settings
              </Typography>
            )}
            <DeploymentSettingsField
              deploymentEnv={deploymentEnv}
              setDeploymentEnv={setDeploymentEnv}
              enableJavascript={enableJavascript}
              setEnableJavascript={setEnableJavascript}
              journeyInsightsSettings={journeyInsightsSettings}
              setJourneyInsightsSettings={setJourneyInsightsSettings}
              lockJavascriptField={false}
              containerStyle={{ my: 2 }}
              style={{ width: '50%', color: 'text.secondary' }}
            />
          </Box>
        )}
        {!preUploadView && (
          <PolicyUploadUIComponent
            deployState={deployState}
            showPolicyName={true}
            deploymentTenantId={editorState.templatization.environments[deploymentEnv].settings[jsonConstants.defaultAppSettingFields.Tenant.id]}
          />
        )}
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, PolicyUploadUIComponent);
export default PolicyUploadUIModalComponent;
